<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <div ref="printHack" style="display: none;"></div>
    <v-card>
      <v-card-title>
        <span class="headline">Impressão :</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-dialog ref="printToggleStartDate" v-model="printToggleStartDate" :return-value.sync="printStartDate"
                persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="printStartDate" label="Data De:" v-on="on" clearable></v-text-field>
                </template>
                <v-date-picker :max="printEndDate" locale="pt-pt" v-model="printStartDate" scrollable>
                  <v-btn text color="primary" @click="printToggleStartDate = false">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="$refs.printToggleStartDate.save(printStartDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-dialog ref="printToggleEndDate" v-model="printToggleEndDate" :return-value.sync="printEndDate" persistent
                width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="printEndDate" label="Data Até:" v-on="on" clearable></v-text-field>
                </template>
                <v-date-picker :min="printStartDate" locale="pt-pt" v-model="printEndDate" scrollable>
                  <v-btn text color="primary" @click="printToggleEndDate = false">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="$refs.printToggleEndDate.save(printEndDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select v-model="printAddressId" :items="addresses" item-text="value" item-value="id"
                label="Loja"></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select v-model="docType" :items="docTypes" item-text="name" item-value="value"
                label="Documento"></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-switch v-model="printShowOnlyRedDocs" label="Ver apenas documentos por liquidar"></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-switch v-model="printIncludeLines" label="Incluir detalhes dos documentos"></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-switch v-model="printConvertValues" :label="`Converter Valores para : ${defaultCurrency}`"></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="printing" text @click="cleanFiltersPrint()">Limpar</v-btn>
        <v-spacer />
        <div class="flex-grow-1"></div>
        <v-btn color="blue darken-1" :disabled="printing" text @click="show = false">Fechar</v-btn>
        <v-btn color="blue darken-1" :loading="printing" text @click="print()">Imprimir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ServiceLedger from "@/services/ServiceLedger";

// import Docxtemplater from "docxtemplater";
// import { saveAs } from "file-saver";

import _ from "lodash";

export default {
  name: "print-dialog",
  props: ["selectedClient", "printFile", "docTypes", "addresses", "defaultCurrency"],
  data() {
    return {
      printStartDate: null,
      printToggleStartDate: false,
      printEndDate: null,
      printToggleEndDate: false,
      printShowOnlyRedDocs: false,
      printAddressId: null,
      printIncludeLines: false,
      printConvertValues: false,
      docType: '',
      printing: false,
      show: false,
    };
  },
  methods: {
    toggle() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    cleanFiltersPrint() {
      this.printStartDate = null;
      this.printAddressId = null;
      this.printEndDate = null;
      this.printShowOnlyRedDocs = false;
      this.printIncludeLines = false;
      this.printConvertValues = false;
      this.docType = "";
    },
    async print() {
      try {
        this.printing = true;
        let info;

        if (this.$store.state.user.level == 2) {
          info = await ServiceLedger.printAdmin(
            this.selectedClient.id,
            this.printAddressId,
            this.printStartDate,
            this.printEndDate,
            this.printShowOnlyRedDocs,
            this.printIncludeLines,
            this.printConvertValues,
            this.defaultCurrency,
            this.docType
          );
        }

        if (this.$store.state.user.level == 1) {
          info = await ServiceLedger.printSalesman(
            this.selectedClient.id,
            this.printAddressId,
            this.printStartDate,
            this.printEndDate,
            this.printShowOnlyRedDocs,
            this.printIncludeLines,
            this.printConvertValues,
            this.defaultCurrency,
            this.docType
          );
        }

        if (this.$store.state.user.level == 0) {
          info = await ServiceLedger.print(
            this.printAddressId,
            this.printStartDate,
            this.printEndDate,
            this.printShowOnlyRedDocs,
            this.printIncludeLines,
            this.printConvertValues,
            this.defaultCurrency,
            this.docType
          );
        }

        this.$refs.printHack.innerHTML = this.printFile;

        let clientNode = this.$refs.printHack.querySelector('#client');

        let generalTotals = this.$refs.printHack.querySelector('#generalTotals');

        for (const property in info.data) {
          if (!(info.data[property] instanceof Array)) {
            generalTotals.innerHTML = generalTotals.innerHTML.replace(`{${property}}`, info.data[property]);
          }
        }

        let mainRowClone;
        let clientNodeClone;
        let mainBody;
        let mainRow;
        let detailBody;
        let detailTableClone;
        let detailRow;
        let detailRowClone;
        let detailTitle;
        let detailsTable;
        _.forEach(info.data.clients, (client) => {
          clientNodeClone = clientNode.cloneNode(true);

          for (const property in client) {
            if (!(info.data[property] instanceof Array)) {
              clientNodeClone.innerHTML = clientNodeClone.innerHTML.replace(`{${property}}`, client[property]);
            }
          }

          mainBody = clientNodeClone.querySelector('#mainBody');
          mainRow = mainBody.querySelector('#mainRow');
          detailsTable = mainBody.querySelector('#detailsTable');


          _.forEach(client.ledger, (ledger) => {
            mainRowClone = mainRow.cloneNode(true);

            for (const property in ledger) {
              if (!(info.data[property] instanceof Array)) {
                mainRowClone.innerHTML = mainRowClone.innerHTML.replace(`{${property}}`, ledger[property]);
              }
            }

            mainBody.append(mainRowClone);

            if (this.printIncludeLines) {
              detailTableClone = detailsTable.cloneNode(true);

              detailBody = detailTableClone.querySelector('#detailsBody');
              detailRow = detailBody.querySelector('#detailRow');
              detailTitle = detailBody.querySelector('#detailsTitle');

              mainBody.append(detailTableClone);

              detailTitle.innerHTML = detailTitle.innerHTML.replace('{externalId}', ledger.externalId);
              _.forEach(ledger.LedgerLines, (line) => {
                detailRowClone = detailRow.cloneNode(true);

                for (const property in line) {
                  if (!(info.data[property] instanceof Array)) {
                    detailRowClone.innerHTML = detailRowClone.innerHTML.replace(`{${property}}`, line[property]);
                  }
                }

                detailBody.append(detailRowClone);
              });
              detailRow.remove();
            }

          });
          detailsTable.remove();
          mainRow.remove();
          this.$refs.printHack.append(clientNodeClone);
        });

        clientNode.remove();

        var mywindow = window.open();

        mywindow.document.write(this.$refs.printHack.innerHTML);
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();

        this.printing = false;
      } catch (error) {
        console.log(error)
        this.printing = false;
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: "Ocorreu um erro, por favor tente novamente",
        });
      }
    },
  },
};
</script>
<style></style>
